import React, { useRef, useState } from "react";
import { Button } from "../../../../../shared/Button/Button";
import styles from "../scss/PosDisputesFiles.module.scss";
import { AngleDownIcon } from "../../../../../assets/Icons/AngleDownIcon";
import { useClickOutside } from "../../../../../utilities/hooks/useClickOutside";

const PosDisputesFiles = ({ files = [] }) => {
  const [showFilesList, setShowFilesList] = useState(false);
  const filesList = useRef(null);

  useClickOutside(filesList, () => setShowFilesList(false));

  return (
    <div className={styles.filesContainer}>
      <Button
        size="small"
        variant="outlined"
        onClick={() => setShowFilesList(true)}
        className={styles.filesButton}
        rightAdornment={
          <AngleDownIcon width="10px" styles={{ position: "static" }} />
        }
      >
        Dispute Files
      </Button>
      {showFilesList && (
        <ul className={styles.filesListContainer} ref={filesList}>
          {files.map((file, index) => (
            <li key={index}>
              <a href={file} target="_blank" rel="noopener noreferrer">
                {files.length > 1
                  ? `Dispute File ${index + 1}`
                  : "Dispute File"}
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default PosDisputesFiles;
